<template>
  <!-- prettier-ignore -->
  <div
    :class="classes"
    :cy-radio-group="name"
    :cy-test="value || 'false'">
    <template v-for="item in items">
      <ovp-radio
        class="group__item"
        :disabled="readonly && item.value !== value"
        :name="name"
        :input="value"
        :theme="theme"
        :value="item.value"
        @update="emitUpdate(item.value)">
        <template v-if="raw"><span v-html="item.text" /></template>
        <template v-else>{{$t(item.text)}}</template>
      </ovp-radio>
    </template>
  </div>
</template>

<script>
export default {
  name: 'OvpRadioGroup',

  model: {
    prop: 'value',
    event: 'update'
  },

  props: {
    vertical: {
      type: Boolean,
      default: false
    },

    items: {
      type: Array,
      required: true
    },

    name: {
      type: String,
      required: true
    },

    raw: {
      type: Boolean,
      default: false
    },

    readonly: {
      type: Boolean,
      default: false
    },

    theme: {
      type: String,
      default: 'light'
    },

    value: {
      type: [String, Number, Boolean]
    },

    validate: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    classes() {
      return {
        group: true,
        'group--invalid': this.invalid,
        'group--vertical': this.vertical
      }
    },

    invalid() {
      return this.validate?.$invalid && this.validate?.$error
    }
  },

  methods: {
    emitUpdate(value) {
      this.validate?.$touch()
      this.$emit('update', value)
    }
  }
}
</script>

<style name="mobile" scoped>
.group {
  display: flex;
  flex-direction: row;

  &__item {
     margin: 5px 25px 5px 0;
     min-width: 75px;
  }

  &--vertical {
    flex-direction: column;
  }

  &--invalid {
    .group__item {
      color: var(--c-error);
    }
  }
}
</style>

<style name="desktop" scoped>
@media (--md) {
  .group {
    &__item {
    }
  }
}
</style>
